import classNames from "classnames";
import * as React from "react";

import BlinkingOnClickComponent from "../BlinkingOnClickComponent/BlinkingOnClickComponent";

// tslint:disable-next-line:no-var-requires
const style = require("./OkButton.scss");

export interface OkButtonProps {
    readonly className?: string;
    readonly click?: () => void;
    readonly isActive?: boolean;
}

export default function OkButton({
    click,
    className,
    isActive = false
}: OkButtonProps) {
    return (
        <BlinkingOnClickComponent activeClassName={style.active}>
            <button
                className={classNames(className, style.okButton, {
                    [style.active]: isActive
                })}
                onClick={click}
            >
                OK
            </button>
        </BlinkingOnClickComponent>
    );
}
